
  export default {
    CompetencyA: 'AonHewittA',
    CompetencyB: 'AonHewittB',
  } as any